import { render, staticRenderFns } from "./navigationAdminPage.vue?vue&type=template&id=4558cbfa&scoped=true"
import script from "./navigationAdminPage.vue?vue&type=script&lang=js"
export * from "./navigationAdminPage.vue?vue&type=script&lang=js"
import style0 from "./navigationAdminPage.vue?vue&type=style&index=0&id=4558cbfa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4558cbfa",
  null
  
)

export default component.exports